var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState, useEffect } from 'react';
import { loadCssDesign } from '../utils/Utils';
var TouristFooter = function (_a) {
    var requestGet = _a.requestGet, RESPONSE = _a.RESPONSE, CONSTANTS_REQ = _a.CONSTANTS_REQ, getSelectedClientLanguage = _a.getSelectedClientLanguage, getTranslated = _a.getTranslated, projectId = _a.projectId, projectType = _a.projectType, dataFooterText = _a.dataFooterText, dataFooterLogo = _a.dataFooterLogo, settings = _a.settings, cssId = _a.cssId;
    var _b = useState(dataFooterText), footerText = _b[0], setFooterText = _b[1];
    var _c = useState(dataFooterLogo), footerLogo = _c[0], setFooterLogo = _c[1];
    var _d = useState([]), icons = _d[0], setIcons = _d[1];
    var projectDefault = 0;
    var setLang = getSelectedClientLanguage();
    useEffect(function () {
        //getSettings();
        //getFooterLogo();
        if (settings) {
            if (settings != null && settings['footer.text' + (projectType != undefined ? '.' + projectType : '')] != null) {
                setFooterText(settings['footer.text' + (projectType != undefined ? '.' + projectType : '')]);
            }
            if (settings['footer.logo'] != null) {
                setFooterLogo(JSON.parse(settings['footer.logo']));
            }
            if (settings && settings["footer.icons"] != null) {
                setIcons(JSON.parse(settings["footer.icons"]));
            }
            if (settings.footerCSS) {
                loadCssDesign(cssId, settings.footerCSS, CONSTANTS_REQ);
            }
        }
    }, []);
    function getSettings() {
        return __awaiter(this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestGet(CONSTANTS_REQ.CLIENT.SETTINGS_EDIT, {
                            group: 'footer',
                            key: 'footer.text' + (projectType != undefined ? '.' + projectType : ''),
                            projectId: projectDefault,
                        })];
                    case 1:
                        resp = _a.sent();
                        if (resp.status === RESPONSE.OK) {
                            setFooterText(resp.data.settingValue);
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    function getFooterLogo() {
        return __awaiter(this, void 0, void 0, function () {
            var resp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, requestGet(CONSTANTS_REQ.CLIENT.SETTINGS_EDIT, {
                            group: 'footer',
                            key: 'footer.logo',
                            projectId: projectId,
                        })];
                    case 1:
                        resp = _a.sent();
                        if (resp.status === RESPONSE.OK) {
                            if (resp.data.settingValue != null) {
                                setFooterLogo(JSON.parse(resp.data.settingValue));
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    }
    return (React.createElement("footer", { id: cssId },
        footerLogo && footerLogo.file_path != undefined && (React.createElement("div", { className: "tourist-footer" },
            projectType === ProjectType.WEB && React.createElement("div", { className: "icons" }, (icons && icons.map(function (icon) {
                return React.createElement("a", { style: { marginRight: '5px' }, target: "_blank", href: icon.url != null ? encodeURI(icon.url) : undefined },
                    React.createElement("img", { className: 'footer-iconFooter', src: CONSTANTS_REQ.STATIC + projectId + (icon.image ? encodeURI(icon.image["file_path"]) : undefined), height: "25px", width: "25px", alt: icon.text != null ? icon.text : undefined }));
            }))),
            React.createElement("div", { className: "tourist-footer-grid" },
                React.createElement("div", { className: "tourist-pull-left" },
                    React.createElement("div", { className: "tourist-footer-text" }, footerText != null && getTranslated(footerText, setLang))),
                React.createElement("div", { className: "tourist-pull-right" },
                    React.createElement("img", { className: "tourist-logo", src: CONSTANTS_REQ.STATIC + projectId + encodeURI(footerLogo.file_path), alt: "logo" }))))),
        !footerLogo && (React.createElement("div", { className: "tourist-footer-no-logo" },
            projectType === ProjectType.WEB && React.createElement("div", { className: "icons" }, (icons && icons.map(function (icon) {
                return React.createElement("a", { style: { marginRight: '5px' }, target: "_blank", href: icon.url != null ? encodeURI(icon.url) : undefined },
                    React.createElement("img", { className: 'footer-iconFooter', src: CONSTANTS_REQ.STATIC + projectId + (icon.image ? encodeURI(icon.image["file_path"]) : undefined), height: "25px", width: "25px", alt: icon.text != null ? icon.text : undefined }));
            }))),
            React.createElement("div", { className: "tourist-footer-text-no-logo" }, footerText != null && getTranslated(footerText, setLang))))));
};
export default TouristFooter;
export var ProjectType;
(function (ProjectType) {
    ProjectType["WEB"] = "web";
    ProjectType["KIOSK"] = "kiosk";
})(ProjectType || (ProjectType = {}));
//# sourceMappingURL=index.js.map